export type RegionCode = 'US' | 'UK' | 'MX' | 'FR' | 'DE';
export const regions: RegionCode[] = ['US', 'UK', 'MX', 'FR', 'DE'];
export const flagSelectorRegions: RegionCode[] = ['UK', 'FR', 'DE'];

export interface Region {
  /**
   * Country identifier e.g. US or MX.
   */
  country: string;

  /**
   * Region identifier e.g. US, UK, FR or DE.
   */
  region: RegionCode;
}

export function isRegion(region: string | RegionCode): region is RegionCode {
  return regions.indexOf(region as never) !== -1;
}

export function isNorthAmerica(region: RegionCode): boolean {
  return region === 'US' || region === 'MX';
}

export function isEurope(region: RegionCode): boolean {
  return region === 'UK' || region === 'FR' || region === 'DE';
}

export function getDefaultRegion(): RegionCode {
  return regions[0];
}
